import {
    Analytics,
    safeWrap,
    getSelectedFamilyName,
    getLocationFilter,
    getSelectedSortOption,
    PHONE_LINK_SELECTOR,
    ADD_TO_CART_SELECTOR,
    NO_RESULT_TECHNICAL_SUPPORT_SELECTOR,
} from '../../analytics/analytics';

const PAGE = 'searchServicePage';

const MODEL_NUMBER_SELECTOR = '#modelNumber-input';
const PRODUCT_ITEM_SELECTOR = 'li.result-list__item_product';

const { apcLogService } = window;

const preload = safeWrap('preload');
const setVariables = safeWrap('setVariables');
const setPageReady = safeWrap('setPageReady');
const getDefaultPageReadyPromise = safeWrap('getDefaultPageReadyPromise');

class ServiceAnalytics extends Analytics {
    constructor() {
        super();
        this.PAGE = PAGE;
    }

    handleEngagementClick = e => {
        super.handleEngagementClick(e);
        const { target } = e;
        let block = null;
        if (this.matchThisOrChildren(target, PHONE_LINK_SELECTOR)) {
            block = this.getClosest(target, PRODUCT_ITEM_SELECTOR);
            const metaPhoneNumber = document.querySelector('meta[name="tagging-site-phone"]');
            apcLogService(`${this.PAGE}.phone.click`, {
                target,
                productId: block.dataset.productId || '',
                phoneNumber: metaPhoneNumber ? metaPhoneNumber.content : '',
                url: window.location.href,
            });
        } else if (this.matchThisOrChildren(target, ADD_TO_CART_SELECTOR)) {
            block = this.getClosest(target, PRODUCT_ITEM_SELECTOR);
            apcLogService(`${this.PAGE}.addToCart.click`, {
                target,
                productId: block.dataset.productId || '',
                url: window.location.href,
            });
        }
    };

    handleEventsClick(e) {
        super.handleEventsClick(e);
        const { target } = e;
        if (this.matchThisOrChildren(target, NO_RESULT_TECHNICAL_SUPPORT_SELECTOR)) {
            this.supportNoResults(target);
        }
    }
}

try {
    preload(PAGE);
    setPageReady(
        getDefaultPageReadyPromise().then(() => {
            const modelNumber = document.querySelector(MODEL_NUMBER_SELECTOR);
            const isSelect = modelNumber && !!modelNumber.dataset.partNumber;
            setVariables({
                env_template: 'selector',
                page_name: 'service-selector_step3-recommendations',
                page_cat1: 'service-selector',
                page_level: '104',
                sales_insights: '1',
                selector_sort_option: getSelectedSortOption(),
                selector_country_filter: getLocationFilter(),
                selector_model_family: getSelectedFamilyName(),
                selector_sku: isSelect && modelNumber ? modelNumber.dataset.skuId : '',
            });
            new ServiceAnalytics().init();
        }),
    );
} catch (err) {
    console.error(err);
}
